import getCart from './getCart';
import updateCartCount from './updateCartCount';

const changeCart = async (lineItemKey, qty) => {
  const item = {
    id: lineItemKey,
    quantity: qty
  };

  const change = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(item)
  });

  if (!change.ok) {
    let err = {};
    try { err = await change.json(); } catch { /* ignore */ }
    throw new Error(err.description || `Cart change failed (${change.status})`);
  }

  const changeData = await change.json();

  try {
    const cart = await getCart();
    if (cart) updateCartCount(cart.item_count);
  } catch { /* non-critical */ }

  return changeData;
};

export default changeCart;
